import { loadStripe, type Stripe } from '@stripe/stripe-js';

/**
 * Загрузка Stripe.js (FE-480).
 *
 * Скрипт платёжной системы подтягивается **по требованию**, а не при старте
 * приложения: экран оплаты видит меньшинство пользователей, а скрипт весит и
 * ставит cookie. Загружать его на главной значило бы платить за это всем.
 *
 * Результат кешируется по ключу: `loadStripe` при каждом вызове создаёт новый
 * экземпляр, и повторный рендер экрана пересоздавал бы всю платёжную форму —
 * с потерей уже введённых данных.
 *
 * Ключ — **публикуемый**: он для того и существует, чтобы быть в браузере.
 * Секретный ключ сюда не попадает никогда и приходить не может: его нет ни в
 * одном ответе API.
 */
const cache = new Map<string, Promise<Stripe | null>>();

export function getStripe(publishableKey: string): Promise<Stripe | null> {
  const cached = cache.get(publishableKey);
  if (cached) return cached;
  const promise = loadStripe(publishableKey);
  cache.set(publishableKey, promise);
  return promise;
}
